import { fromJS } from 'immutable';
import { visibleColumns as visibleRunupColumns, sort as runupSort } from '../../tsunamis/event/related-runup/runupReduxConstants';
import { basicSort } from '../../../util/sortUtils';
import { visibleColumns as visibleTsunamiColumns, sort as tsunamiSort } from '../../tsunamis/event/data/tsunamiReduxConstants';
import { visibleColumns as visibleEarthquakeColumns, sort as earthquakeSort } from '../../earthquakes/data/earthquakeReduxConstants';
import { visibleColumns as visibleVolcanoColumns, sort as volcanoSort } from '../../volcanoes/event/data/volcanoEventReduxConstants';

export const CLEAR_REFERENCE_INFO = 'CLEAR_REFERENCE_INFO';

export const REFERENCE_INFO_REQUEST = 'REFERENCE_INFO_REQUEST';
export const REFERENCE_INFO_SUCCESS = 'REFERENCE_INFO_SUCCESS';
export const REFERENCE_INFO_FAILURE = 'REFERENCE_INFO_FAILURE';

export const REFERENCE_INFO_RUNUP_SORT = 'REFERENCE_INFO_RUNUP_SORT';
export const REFERENCE_INFO_RUNUP_TOGGLE_COLUMN = 'REFERENCE_INFO_RUNUP_TOGGLE_COLUMN';
export const REFERENCE_INFO_RUNUP_REQUEST = 'REFERENCE_INFO_RUNUP_REQUEST';
export const REFERENCE_INFO_RUNUP_SUCCESS = 'REFERENCE_INFO_RUNUP_SUCCESS';
export const REFERENCE_INFO_RUNUP_FAILURE = 'REFERENCE_INFO_RUNUP_FAILURE';
export const REFERENCE_INFO_RUNUP_DELETE_REQUEST = 'REFERENCE_INFO_RUNUP_DELETE_REQUEST';
export const REFERENCE_INFO_RUNUP_DELETE_SUCCESS = 'REFERENCE_INFO_RUNUP_DELETE_SUCCESS';
export const REFERENCE_INFO_RUNUP_DELETE_FAILURE = 'REFERENCE_INFO_RUNUP_DELETE_FAILURE';


export const REFERENCE_INFO_TSUNAMI_SORT = 'REFERENCE_INFO_TSUNAMI_SORT';
export const REFERENCE_INFO_TSUNAMI_TOGGLE_COLUMN = 'REFERENCE_INFO_TSUNAMI_TOGGLE_COLUMN';
export const REFERENCE_INFO_TSUNAMI_REQUEST = 'REFERENCE_INFO_TSUNAMI_REQUEST';
export const REFERENCE_INFO_TSUNAMI_SUCCESS = 'REFERENCE_INFO_TSUNAMI_SUCCESS';
export const REFERENCE_INFO_TSUNAMI_FAILURE = 'REFERENCE_INFO_TSUNAMI_FAILURE';
export const REFERENCE_INFO_TSUNAMI_DELETE_REQUEST = 'REFERENCE_INFO_TSUNAMI_DELETE_REQUEST';
export const REFERENCE_INFO_TSUNAMI_DELETE_SUCCESS = 'REFERENCE_INFO_TSUNAMI_DELETE_SUCCESS';
export const REFERENCE_INFO_TSUNAMI_DELETE_FAILURE = 'REFERENCE_INFO_TSUNAMI_DELETE_FAILURE';


export const REFERENCE_INFO_EARTHQUAKE_SORT = 'REFERENCE_INFO_EARTHQUAKE_SORT';
export const REFERENCE_INFO_EARTHQUAKE_TOGGLE_COLUMN = 'REFERENCE_INFO_EARTHQUAKE_TOGGLE_COLUMN';
export const REFERENCE_INFO_EARTHQUAKE_REQUEST = 'REFERENCE_INFO_EARTHQUAKE_REQUEST';
export const REFERENCE_INFO_EARTHQUAKE_SUCCESS = 'REFERENCE_INFO_EARTHQUAKE_SUCCESS';
export const REFERENCE_INFO_EARTHQUAKE_FAILURE = 'REFERENCE_INFO_EARTHQUAKE_FAILURE';
export const REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST = 'REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST';
export const REFERENCE_INFO_EARTHQUAKE_DELETE_SUCCESS = 'REFERENCE_INFO_EARTHQUAKE_DELETE_SUCCESS';
export const REFERENCE_INFO_EARTHQUAKE_DELETE_FAILURE = 'REFERENCE_INFO_EARTHQUAKE_DELETE_FAILURE';


export const REFERENCE_INFO_VOLCANO_SORT = 'REFERENCE_INFO_VOLCANO_SORT';
export const REFERENCE_INFO_VOLCANO_TOGGLE_COLUMN = 'REFERENCE_INFO_VOLCANO_TOGGLE_COLUMN';
export const REFERENCE_INFO_VOLCANO_REQUEST = 'REFERENCE_INFO_VOLCANO_REQUEST';
export const REFERENCE_INFO_VOLCANO_SUCCESS = 'REFERENCE_INFO_VOLCANO_SUCCESS';
export const REFERENCE_INFO_VOLCANO_FAILURE = 'REFERENCE_INFO_VOLCANO_FAILURE';
export const REFERENCE_INFO_VOLCANO_DELETE_REQUEST = 'REFERENCE_INFO_VOLCANO_DELETE_REQUEST';
export const REFERENCE_INFO_VOLCANO_DELETE_SUCCESS = 'REFERENCE_INFO_VOLCANO_DELETE_SUCCESS';
export const REFERENCE_INFO_VOLCANO_DELETE_FAILURE = 'REFERENCE_INFO_VOLCANO_DELETE_FAILURE';


const initialState = fromJS({

  fetchedReference: false,
  reference: {},

  fetchedVolcanoes: false,
  volcanoes: [],
  deletingVolcano: false,
  volcanoSort,
  visibleVolcanoColumns,

  fetchedEarthquakes: false,
  earthquakes: [],
  deletingEarthquake: false,
  earthquakeSort,
  visibleEarthquakeColumns,

  fetchedTsunamis: false,
  tsunamis: [],
  deletingTsunami: false,
  tsunamiSort,
  visibleTsunamiColumns,

  fetchedRunups: false,
  runups: [],
  deletingRunup: false,
  runupSort,
  visibleRunupColumns,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const referenceInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_REFERENCE_INFO:
      return initialState.merge(fromJS({
        volcanoSort: state.get('volcanoSort'),
        visibleVolcanoColumns: state.get('visibleVolcanoColumns'),
        earthquakeSort: state.get('earthquakeSort'),
        visibleEarthquakeColumns: state.get('visibleEarthquakeColumns'),
        tsunamiSort: state.get('tsunamiSort'),
        visibleTsunamiColumns: state.get('visibleTsunamiColumns'),
        runupSort: state.get('runupSort'),
        visibleRunupColumns: state.get('visibleRunupColumns'),
      }));


    case REFERENCE_INFO_REQUEST:
      return state.merge(fromJS({
        fetchedReference: false,
      }));
    case REFERENCE_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedReference: true,
        reference: action.response,
      }));
    case REFERENCE_INFO_FAILURE:
      return state.merge(fromJS({
        fetchedReference: true,
      }));


    case REFERENCE_INFO_RUNUP_SORT:
      return state.merge(fromJS({
        runups: basicSort(action.sort, state.get('runups')),
        runupSort: action.sort,
      }));

    case REFERENCE_INFO_RUNUP_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleRunupColumns: action.visibleColumns,
      }));

    case REFERENCE_INFO_RUNUP_REQUEST:
      return state.merge(fromJS({
        fetchedRunups: false,
      }));
    case REFERENCE_INFO_RUNUP_SUCCESS:
      return state.merge(fromJS({
        fetchedRunups: true,
        runups: basicSort(state.get('runupSort'), fromJS(action.response.items)),
      }));
    case REFERENCE_INFO_RUNUP_FAILURE:
      return state.merge(fromJS({
        fetchedRunups: true,
      }));

    case REFERENCE_INFO_RUNUP_DELETE_REQUEST:
      return state.set('deletingRunup', true);
    case REFERENCE_INFO_RUNUP_DELETE_SUCCESS:
    case REFERENCE_INFO_RUNUP_DELETE_FAILURE:
      return state.set('deletingRunup', false);


    case REFERENCE_INFO_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamis: basicSort(action.sort, state.get('tsunamis')),
        tsunamiSort: action.sort,
      }));

    case REFERENCE_INFO_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleTsunamiColumns: action.visibleColumns,
      }));

    case REFERENCE_INFO_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunamis: false,
      }));
    case REFERENCE_INFO_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunamis: true,
        tsunamis: basicSort(state.get('tsunamiSort'), fromJS(action.response.items)),
      }));
    case REFERENCE_INFO_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunamis: true,
      }));

    case REFERENCE_INFO_TSUNAMI_DELETE_REQUEST:
      return state.set('deletingTsunami', true);
    case REFERENCE_INFO_TSUNAMI_DELETE_SUCCESS:
    case REFERENCE_INFO_TSUNAMI_DELETE_FAILURE:
      return state.set('deletingTsunami', false);


    case REFERENCE_INFO_EARTHQUAKE_SORT:
      return state.merge(fromJS({
        earthquakes: basicSort(action.sort, state.get('earthquakes')),
        earthquakeSort: action.sort,
      }));

    case REFERENCE_INFO_EARTHQUAKE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleEarthquakeColumns: action.visibleColumns,
      }));

    case REFERENCE_INFO_EARTHQUAKE_REQUEST:
      return state.merge(fromJS({
        fetchedEarthquakes: false,
      }));
    case REFERENCE_INFO_EARTHQUAKE_SUCCESS:
      return state.merge(fromJS({
        fetchedEarthquakes: true,
        earthquakes: basicSort(state.get('earthquakeSort'), fromJS(action.response.items)),
      }));
    case REFERENCE_INFO_EARTHQUAKE_FAILURE:
      return state.merge(fromJS({
        fetchedEarthquakes: true,
      }));


    case REFERENCE_INFO_EARTHQUAKE_DELETE_REQUEST:
      return state.set('deletingEarthquake', true);
    case REFERENCE_INFO_EARTHQUAKE_DELETE_SUCCESS:
    case REFERENCE_INFO_EARTHQUAKE_DELETE_FAILURE:
      return state.set('deletingEarthquake', false);


    case REFERENCE_INFO_VOLCANO_SORT:
      return state.merge(fromJS({
        volcanoes: basicSort(action.sort, state.get('volcanoes')),
        volcanoSort: action.sort,
      }));

    case REFERENCE_INFO_VOLCANO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleVolcanoColumns: action.visibleColumns,
      }));

    case REFERENCE_INFO_VOLCANO_REQUEST:
      return state.merge(fromJS({
        fetchedVolcanoes: false,
      }));
    case REFERENCE_INFO_VOLCANO_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcanoes: true,
        volcanoes: basicSort(state.get('volcanoSort'), fromJS(action.response.items)),
      }));
    case REFERENCE_INFO_VOLCANO_FAILURE:
      return state.merge(fromJS({
        fetchedVolcanoes: true,
      }));

    case REFERENCE_INFO_VOLCANO_DELETE_REQUEST:
      return state.set('deletingVolcano', true);
    case REFERENCE_INFO_VOLCANO_DELETE_SUCCESS:
    case REFERENCE_INFO_VOLCANO_DELETE_FAILURE:
      return state.set('deletingVolcano', false);


    default:
      return state;
  }
};
